<form #f="ngForm">
	<ng-container *ngIf="isCommodityTypeSelectionAllowed">
		<mat-form-field appearance="fill"
			class="mat-form-field--one-line mat-form-field--short">
			<mat-label>
				{{ 'Commodity' | translate }}
			</mat-label>
			<mat-select (ngModelChange)="onCommodityTypeSelected($event)"
				required
				name="commodityTypeId"
				[(ngModel)]="commodityTypeId">
				<mat-select-trigger *ngIf="selectedCommodityType">
					{{ selectedCommodityType.Name | translate }} <mat-icon class="cm-mat-select-trigger__mat-icon"
					*ngIf="!selectedCommodityType.IsActive">construction</mat-icon>
				</mat-select-trigger>
				<mat-option [value]="null">
					{{'Select One' | translate }}
				</mat-option>
				<mat-option *ngFor="let commodityType of commodityTypes"
					[value]="commodityType.Id">
					{{commodityType.Name | translate }} <mat-icon *ngIf="!commodityType.IsActive">construction</mat-icon>
				</mat-option>
			</mat-select>
		</mat-form-field>
	</ng-container>

	<ng-container *ngIf="cropTypes && cropTypes.length > 0">
		<label>
			{{ 'Crop Types' | translate }}
			<info-icon *ngIf="!isRanchAgnostic"
				[title]="'Crop Types Planting Count Help Text'"></info-icon>
		</label>

		<p>
			Choose crop types that best fit the crops you grow. Exact matches are not required.
		</p>

		<ng-container *ngFor="let cropType of cropTypes">
			<div class="bk-modal__row bk-modal__row--no-border">
				<input type="checkbox"
					class="bk-modal__checkbox"
					name="cropType{{cropType.Id}}"
					value="cropType"
					(change)="onCropTypeChange()"
					[disabled]="cropType.PlantingsCount > 0"
					[(ngModel)]="cropType.IsSelected" />

				<span>
					{{cropType.Name | translate }}
					<span *ngIf="cropType.PlantingsCount > 0">
						({{cropType.PlantingsCount}})
					</span>
				</span>
			</div>
		</ng-container>
	</ng-container>
</form>
